export const PARTICIPANT_STATUSES_WITH_IDS = [
  { id: 1, label: 'Registered' },
  { id: 2, label: 'Confirmed' },
  { id: 3, label: 'Attended' },
  { id: 4, label: 'Invitation Declined' },
  { id: 5, label: 'No-show' },
  { id: 6, label: 'Cancelled' },
];
